import axiosRequest from './restapi';

export const getUserProfile = (userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: 'users/profile',
    },
    userToken
  );
};

export const editUserProfile = (data: any, userToken: string) => {
  return axiosRequest(
    {
      method: 'patch',
      url: 'users/profile',
      data,
    },
    userToken
  );
};
